// Module
var code = "<div layout=\"row\" layout-align=\"center center\" class=\"subtask-status-button br-caption-2 font-weight-500\" ng-class=\"$ctrl.status\"> <span>{{'SUB_TASK_STATUS.' + $ctrl.status | translate}}</span> </div> ";
// Exports
export default code;